export interface ColumnMapping {
  csvColumn: string;
  templateField: string;
  format: string;
}

export interface DriverImportConfigurationItem {
  hasHeaders: boolean;
  companyId: string;
  columnMappings: ColumnMapping[];
  createdAt: string;
  skipRows: number;
  configId: string;
  type: string;
}

export interface DriverImportConfiguration {
  items: DriverImportConfigurationItem[];
}
export interface ImportType {
  name: string;
  value: string;
}
export interface PreprocessorConfig {
  action: (file: File) => void;
}
export interface Translation<T = any> {
  [key: string]: T | string | Translation<T>;
}
export interface FileUpload {
  file: File | null;
  isUploadInProgress: boolean;
  uploadResult: string | null;
}
export interface FileUploadConfig {
  mimeTypesAccepted: string;
  data: File | null;
  preprocessor: PreprocessorConfig;
}
export interface ImportConfigurationItem {
  hasHeaders: boolean;
  companyId: string;
  columnMappings: ColumnMapping[];
  createdAt: string;
  skipRows: number;
  configId: string;
  type: string;
  nameFormat?: string;
}
export interface ImportConfiguration {
  items: ImportConfigurationItem[];
}
export interface FieldDefinition {
  fieldKey: string;
  fieldName: string;
  type: 'string' | 'number' | 'boolean' | 'date' | 'array' | 'object';
  required: boolean;
  description?: string;
  dropDownItem: string[];
  formatOptions: string[];
}
export interface RowDefinition {
  destinationColumn: string;
  originColumn: string;
  dropDownItemsOrigin: DropDownItem[];
  dropDownItemsDestination: DropDownItem[];
  dataType: 'string' | 'number' | 'boolean' | 'date' | 'array' | 'object';
  dateFormat: string;
  nameFormat: string;
  description?: string;
  allowedValues?: string[];
  formatOptions: string[];
}
export interface DropDownItem {
  name: string;
  value: string;
}

interface FileEndpoint {
  original?: string;
  [key: string]: any;
}
export interface DriverImportGridData {
  items: DriverImportGridItem[];
}
export interface GridMeta {
  [key: string]: string | number | boolean | object;
}
export interface EventPayload {
  command: string;
  payload?: object;
}
export interface DriverImportGridItem {
  jobId: string;
  importSource: string;
  updateType: string;
  jobStatus: string;
  completedTime: string;
  processedFile: string;
  importedBy: string;
  statistics?: JobStatistics;
  fileEndpoint: FileEndpoint;
  completedAt?: string;
  createdBy?: string;
  createdAt: string;
  approvedBy?: string;
  approvedAt?: string;
  rejectedAt?: string;
  rejectedBy?: string;
  source?: string;
  config?: ImportConfigurationItem;
}

export interface JobStatistics {
  parsedUserCount: number;
  validationErrorsCount: number;
  existingUsersSnapshotCount: number;
  existingUsersStatusCounters: any[];
  usersToBeCreatedCount: number;
  usersToBeUpdatedCount: number;
  usersToBeDeletedCount: number;
  createProcessed: number;
  updateProcessed: number;
  deleteProcessed: number;
  createFailed: number;
  updateFailed: number;
  deleteFailed: number;
  updateChangeCounters: UpdateChangeCounters;
}
export interface CsvMapping {
  format: string;
  csvColumn: string;
  templateField: string;
}
export interface UpdateChangeCounters {
  realStaffNumber: number;
  name: number;
  vrmStatus: number;
  ssoUserId: number;
  email: number;
  employeeNumber: number;
  username: number;
}

export enum DownloadFileType {
  Original = 'original',
  ParsedUserData = 'parsedUserData',
  UsersToBeCreated = 'usersToBeCreated',
  UsersToBeUpdated = 'usersToBeUpdated',
  UsersToBeDeleted = 'usersToBeDeleted',
  ValidationErrors = 'validationErrors',
  ValidationErrorsJson = 'validationErrorsJson',
}

export enum FileMimeType {
  CSV = 'text/csv',
  EXCEL_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  EXCEL_XLS = 'application/vnd.ms-excel',
}
